export default __webpack_public_path__ + "static/media/nutrionist@2x.54a90dc3.png";